import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import MobileEmails from './MobileEmails';
import TransitionAlert from './TransitionAlert';
import { fetchCustomerEmails,setViewCustomerEmails } from '../slices/dataSlice';
import { useMediaQuery, useTheme } from '@mui/material';

import '../css/MobileEmails.css'

function PopupCustomerEmails(props) {
  const dispatch = useDispatch();
  const [openalert, setOpenAlert] = useState(false);
  const [alertmsg, setAlertMsg] = useState('');
  const [previd, setPrevID] = useState(props.id);

  const { customerEmails, viewCustomerEmails } = useSelector((state) => state.data);
  const auth = useSelector((state) => state.auth);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    async function loadEmails() {
      if (props.id === previd) return;
      setPrevID(props.id);

      try {
        const uid = props.data.uid;
        if (uid) {
          dispatch(fetchCustomerEmails(uid));
        }
      } catch (err) {
        console.log('Error loading customer emails:', err);
        setAlertMsg('Error loading emails');
        setOpenAlert(true);
      }
    }

    if (
      auth.token &&
      typeof props.data !== 'undefined' &&
      props.data.id &&
      props.data.uid &&
      props.id
    ) {
      loadEmails();
    }
  }, [props.data, auth.token, props.data.id, props.data.uid, props.id, previd, dispatch]);

  const closeMainDialog = () => {
    dispatch(setViewCustomerEmails(false));
  };

  return (
    <>
      <Dialog
        open={viewCustomerEmails}
        onClose={closeMainDialog}
        PaperProps={{ component: 'paper',
         sx: {
            minWidth: "320px!important",
            maxWidth: isMobile ? '98%' : '90%',
            }
        }}
        sx={{ width: isMobile ? '98%' : '600px', marginLeft: 'auto', marginRight: 'auto' }}
        fullScreen={isMobile}
      >
        <DialogTitle>Customer Emails
        {isMobile && 
        <DialogActions sx={{ justifyContent: isMobile ? 'flex-start' : 'flex-end' }}>
          <Button size="sm" variant="outlined" onClick={closeMainDialog} >
            Close
          </Button>
        </DialogActions>
        }
        </DialogTitle>
        <DialogContent>
          <MobileEmails emails={customerEmails} placement="PopupCustomerEmails" />
        </DialogContent>
        {!isMobile && 
        <DialogActions >
          <Button size="sm" variant="outlined" onClick={closeMainDialog} >
            Close
          </Button>
        </DialogActions>
        }
        <TransitionAlert open={openalert} Close={setOpenAlert} message={alertmsg} />
      </Dialog>
    </>
  );
}

export default PopupCustomerEmails;
